import { gql } from '@apollo/client';

export const ALL_TARGET_GROUPS = gql`
  query AllTargetGroups {
    targetGroups: getTargetGroups {
      id
      name
    }
  }
`;
